import React, { ComponentPropsWithoutRef, useEffect, useState } from "react";
import { useCalendarGroupSessions } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarGroupSessionsContext";
import cancelAppointment from "services/scheduler/cancelAppointment";
import cancelGroupSession from "services/scheduler/cancelGroupSession";
import cancelPatientGroupSession from "services/cancelPatientGroupSession";
import confirmCancelGroupSession from "services/confirmCancelGroupSession";
import ModalLayout from "components/modal/modal-layout/ModalLayout";
import ConfirmModal from "components/confirm-modal";
import messages from "messages";
import { Item } from "components/Dashboard/utility/getItemsByTime";
import { useUser } from "contexts/UserContext";

type Props = ComponentPropsWithoutRef<typeof ModalLayout> & {
  session?: Item;
};

const CancelModal = ({ show, onHide, session }: Props) => {
  const { user } = useUser();
  const [error, setError] = useState<any>();
  const [, setBusy] = useState(false);
  const { reloadGroupSessions } = useCalendarGroupSessions();
  const [bookingDetails, setBookingDetails] = useState({
    cancellation_fee: null,
  });

  useEffect(() => {
    // should reset
    setError(undefined);
    if (!session) {
      return;
    }
    if (
      session.typeId === "GROUP_SESSION" &&
      session.patients &&
      session.orchidPro.cognito_sub !== user?.sub
    ) {
      setBusy(false);
      cancelPatientGroupSession(session.patients[0].booking_id)
        .then(setBookingDetails)
        .catch((e) => setError(e.toString()))
        .finally(() => setBusy(false));
    }
  }, [show, session, user?.sub]);

  const handleConfirm = async () => {
    setError(undefined);
    if (!session) {
      return;
    }
    try {
      setBusy(true);
      if (session.typeId === "ONE_ON_ONE") {
        await cancelAppointment(session.timeslotId);
      } else if (
        // provider cancel a group session they sign up, but not the host
        session.typeId === "GROUP_SESSION" &&
        session.patients &&
        session.orchidPro.cognito_sub !== user?.sub
      ) {
        await confirmCancelGroupSession(session.patients[0].booking_id);
      } else {
        await cancelGroupSession(session.timeslotId);
        reloadGroupSessions();
      }
      window.alert(messages.yourAppointmentWasSuccessfullyCancelled);
      onHide();
    } catch (error) {
      setError(error);
    } finally {
      setBusy(false);
    }
  };

  return (
    <ConfirmModal
      error={error}
      labelTitle={messages.cancelModalTitle}
      children={
        <div>
          {session?.typeId === "ONE_ON_ONE"
            ? "Your patient did not book this session"
            : session?.typeId === "GROUP_SESSION" &&
              session?.patients &&
              session?.orchidPro.cognito_sub !== user?.sub
            ? bookingDetails &&
              `The cancellation fee is $${bookingDetails.cancellation_fee}`
            : messages.allAttendeesWillBeRefunded}
        </div>
      }
      labelCancel={messages.close}
      labelConfirm={messages.confirm}
      show={show}
      onCancel={onHide}
      onConfirm={handleConfirm}
    />
  );
};

export default CancelModal;
